export const REACT_APP_HOSTING_ENV =
  process.env.REACT_APP_HOSTING_ENV || "dev";

// The CE mark is an EU conformity marking, and the ISO badge is shown
// alongside it; neither belongs on the UAE deployment.
export const HIDE_COMPLIANCE_MARKS = REACT_APP_HOSTING_ENV === "uae-prod";

// Release version, set by CI on production builds (MYP-9103). Empty on local/test builds.
export const APP_VERSION = process.env.REACT_APP_VERSION || "";

const Config = (env) => {
  switch (env) {
    case "eu-prod": {
      return [
        {
          env: "production",
          region: "PROD",
          url: "https://api.mypatientspace.com",
          regionCode: "prod",
          appURL: "https://web.mypatientspace.com",
        },
      ];
    }
    case "uae-prod": {
      return [
        {
          env: "production",
          region: "UAE",
          url: "https://uaeapi.mypatientspace.com",
          regionCode: "uae",
          appURL: "https://uae.mypatientspace.com",
        },
      ];
    }
    case "ovh-prod": {
      return [
        {
          env: "production",
          region: "FR",
          url: "http://franceapi.mypatientspace.com",
          regionCode: "fr",
          appURL: "http://france.mypatientspace.com",
        },
      ];
    }
    case "uat":
    case "test":
    case "preprod":
    default: {
      return [
        {
          env: "production",
          region: "PROD",
          url: "https://api.mypatientspace.com",
          regionCode: "prod",
          appURL: "https://web.mypatientspace.com",
        },
        {
          env: "development",
          region: "LOCAL",
          url: "http://localhost:8080",
          regionCode: "lo",
          appURL: "http://localhost:9002",
        },
        {
          env: "development",
          region: "PREPROD",
          url: "https://preprodapi.mypatientspace.com",
          regionCode: "preprod",
          appURL: "https://preprod.mypatientspace.com",
        },
        {
          env: "development",
          region: "TEST",
          url: "https://testapi.mypatientspace.com",
          regionCode: "testweb",
          appURL: "https://test.mypatientspace.com",
        },
        {
          env: "development",
          region: "UAT",
          url: "https://uatapi.mypatientspace.com",
          regionCode: "uat",
          appURL: "https://uat.mypatientspace.com",
        },
        {
          env: "production",
          region: "UAE",
          url: "https://uaeapi.mypatientspace.com",
          regionCode: "uae",
          appURL: "https://uae.mypatientspace.com",
        },
        {
          env: "production",
          region: "FR",
          url: "http://franceapi.mypatientspace.com",
          regionCode: "fr",
          appURL: "http://france.mypatientspace.com",
        },
      ];
    }
  }
};

export default Config(REACT_APP_HOSTING_ENV);
